@if (hasInitFailure) {
  <app-init-error-overlay></app-init-error-overlay>
} @else if (menuEnabled) {
  <mat-drawer-container class="drawer-container">
    <mat-drawer class="app-drawer" mode="side" opened>
      <app-menu></app-menu>
    </mat-drawer>
    <mat-drawer-content class="app-content">
      <app-spinner-overlay></app-spinner-overlay>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
} @else {
  <div>
    <app-spinner-overlay></app-spinner-overlay>
    <router-outlet></router-outlet>
  </div>
}

@if (isSuperAdmin) {
  <button
    type="button"
    class="fixed bottom-0 inset-x-1/2 m-2 z-50 w-[215px]"
    [ngClass]="isEnabledEditableContent ? 'button-regular-accent' : 'button-regular'"
    (click)="switchEditableContent()">
    {{ isEnabledEditableContent ? 'Disable' : 'Enable' }} editable content
  </button>
}
